import { render, staticRenderFns } from "./ResourceUsage.vue?vue&type=template&id=2adc30db&scoped=true"
import script from "./ResourceUsage.vue?vue&type=script&lang=js"
export * from "./ResourceUsage.vue?vue&type=script&lang=js"
import style0 from "./ResourceUsage.vue?vue&type=style&index=0&id=2adc30db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc30db",
  null
  
)

export default component.exports